"use client"
import useSocialUpdates from "@/app/hooks/useSocialUpdates";
import { Skeleton } from "@/app/ui/imported/skeleton";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/ui/imported/tooltip";
import Image from "@/app/ui/utils/Image";
import { cn } from "@/lib/utils";
import { Youtuber } from "@prisma/client";
import Link from "next/link";
import Script from "next/script";
import { Person, WithContext } from "schema-dts";

interface CreatorHeaderProps {
    youtuber: Omit<Youtuber, "userId">,
    liveStatusAlwaysOpen?: boolean,
    asLinkTo?: string,
    className?: string,
    relativeToH?: boolean,
    tooltipSide?: "top" | "right" | "bottom" | "left"
}

function CreatorLogo({ youtuber, liveStatusAlwaysOpen = true, relativeToH = true, tooltipSide = "bottom", asLinkTo, className }: CreatorHeaderProps) {
    const { data: ytData } = useSocialUpdates(youtuber.ytid, true);

    const isLive = (ytData && !("error" in ytData)) && ytData.isStreaming;
    let streamUrl: string | undefined;
    if (isLive)
        streamUrl = ytData?.liveUrl

    const Warper = (isLive || asLinkTo) && Link || "div";
    const linkUrl = streamUrl || asLinkTo || "/";

    const jsonLd: WithContext<Person> = {
        '@context': 'https://schema.org',
        '@type': "Person",
        name: youtuber.name,
        url: `https://www.nightfall.co.il/creator/${youtuber.ytid}`,
        image: youtuber.image,
        sameAs: `https://www.youtube.com/channel/${youtuber.ytid}`
    }

    return (
        <Tooltip open={ liveStatusAlwaysOpen || undefined } >
            <TooltipTrigger asChild>
                <Warper className={ cn(relativeToH && "h-24 sm:h-1em" || "min-w-24 sm:w-1em", "max-w-full aspect-square relative flex items-center btn", className) } href={ linkUrl }>
                    { isLive &&
                        <div className="animate-ping ease-out bg-red-600/80 h-[80%] aspect-square rounded-full m-auto" style={ { animationDuration: "2s" } } />
                    }
                    <Image src={ youtuber.image } alt={ `לוגו ערוץ היוטיוב של ${youtuber.name}` } fill
                        sizes="20vw" className={
                            cn("rounded-full  border-nfPurple-400 border-4",
                                isLive && "border-red-600/50") } />
                    <Script
                        id="creatorLogoScheme"
                        type="application/ld+json"
                        dangerouslySetInnerHTML={ { __html: JSON.stringify(jsonLd) } }
                    />
                </Warper>

            </TooltipTrigger>
            { isLive &&
                <TooltipContent side={ tooltipSide } color="fill-red-600"
                    className="border-red-600 text-base leading-4 bg-black/30 text-shadow-sm max-sm:-translate-y-full max-sm:text-xs text-center">
                    <Link href={ linkUrl } className="font-black block ">
                        אני בלייב!
                    </Link> לחצו בשביל להצטרף!
                </TooltipContent>
            }
        </Tooltip>

    )
}
export default CreatorLogo

export function CreatorLogo_Skeleton({ className }: { className?: string }) {
    return <Skeleton
        className={ cn("min-w-24 sm:w-1em",
            "max-w-full aspect-square rounded-full ",
            className) }
    >
    </Skeleton>
}